const SET_ADMIN_PRIVILEGES = 'SET_ADMIN_PRIVILEGES';
const UPDATE_FILTERED_PROVISIONING_RULES = 'UPDATE_FILTERED_PROVISIONING_RULES';
const SET_API_ERROR_MSG = 'SET_API_ERROR_MSG';

export const ADMIN_PROVISION_ACTION_TYPES = {
    SET_ADMIN_PRIVILEGES,
    UPDATE_FILTERED_PROVISIONING_RULES,
    SET_API_ERROR_MSG,
};
